import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockOpen20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLockOpen20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.953 2.88c-.453.127-.854.348-1.092.707a8 8 0 0 0-.4.651.75.75 0 0 1-1.456-.32L6.75 4c-.745-.083-.745-.084-.745-.085v-.008l.002-.01.003-.017a.8.8 0 0 1 .052-.184q.033-.083.09-.193c.08-.148.215-.377.458-.744.516-.779 1.306-1.147 1.94-1.323a5.2 5.2 0 0 1 1.423-.186l.056.001.065.001A4.406 4.406 0 0 1 14.5 5.658V7.5A2.5 2.5 0 0 1 17 10v6.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 3 16.5V10a2.5 2.5 0 0 1 2.5-2.5H13V5.658a2.906 2.906 0 0 0-2.906-2.906l-.112-.001h-.03a3.8 3.8 0 0 0-.999.13M14.5 9h-9a1 1 0 0 0-1 1v6.5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1M10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockOpen20);
